module.exports = __webpack_public_path__ + "img/bg-grid.33e3acda.svg";